import type React from 'react'

type RaiseError = (error: Error | null) => void
type NotifyError = (message: React.ReactNode) => void

export const notifyIfErrorMessage = (
  data: unknown,
  raiseError: RaiseError,
  notifyError: NotifyError
): void => {
  if (typeof data === 'string') notifyError(data)
  else if (data) raiseError(new Error(JSON.stringify(data)))
}
